export default {
  DISPLAY_TYPE: {
    ALL: 0,
    SCHOOL: 1,
    ME: 2
  },
  TRIGGER_TIME: {
    TIME40: 40,
    TIME60: 60,
    TIME90: 90,
    TIME120: 120
  },
  THEME_ITEM: [
    "现言", "女性成长", "奇幻", "脑洞", "古言", "战神", "宫斗", "玄幻", "权谋", "年代爱情", "仙侠", "种田", "悬疑", "民国爱情", "喜剧", "青春", "志怪", "灵异", "法律", "家国情怀", "民国传奇", "刑侦", "抗战", "武侠", "科幻", "求生", "动作", "恐怖", "商战"
  ],
  SETTING_ITEM: [
    "打脸虐渣", "大男主", "大女主", "马甲", "重生", "穿越", "系统", "先婚后爱", "神豪", "小人物", "豪门", "强者回归", "破镜重圆", "家长里短", "虐恋", "传承觉醒", "异能", "赘婿逆袭", "强强联合", "甜宠", "医生", "娱乐圈", "青梅竹马", "追妻火葬场", "神医", "姐弟恋", "一见钟情", "福宝", "反派主角", "业界精英", "玄学", "萌宠", "白月光", "闹偏门", "灵魂互换", "双向救赎", "病娇", "方言", "暴富", "黑道", "丧尸", "特种兵"
  ],
  BACKGROUND_ITEM: [
    "现代", "都市", "古代", "乡村", "年代", "职场", "架空", "民国", "宫廷", "校园", "荒岛"
  ],
  AUDIENCE_ITEM: [
    "男频", "女频"
  ],
  RECOMMEND_ITEM: [
    "最新", "最热"
  ],
  THEATER_ITEM: [
    "现代", "都市", "古代", "乡村", "年代", "职场", "男频", "女频", "漫剧"
  ]
}